// @flow

import './index.scss';
import * as React from 'react';
import ArticleCard from './Card';
import ArticlesList from './List';

import type { Article } from 'stores/api/articles';

type Props = {|
    data: Article[]
|};

const Articles = ({ data }: Props): React.Node => (
    <div className="Articles">
        <ArticleCard data={data[0]} />
        <ArticlesList data={data.splice(1)} />
    </div>
);

export default Articles;
